import { FileText } from "lucide-react";

export const buildTableStats = (statsConfig, sources) => {
  if (!statsConfig) return { stats: [] };

  const totalApplications = {
    label: "Total",
    value: sources.paginationInfo?.totalCount ?? 0,
    color: "#0E7A6E",
    icon: FileText,
  };

  const buildItems = (items, source) => {
    const upperSource = Object.fromEntries(
      Object.entries(source ?? {}).map(([key, value]) => [
        key.toUpperCase(),
        value,
      ]),
    );

    return items.map(({ label, key, color, urgent, icon, hideWhenZero }) => ({
      label,
      value: upperSource[key.toUpperCase()] ?? 0,
      key,
      color,
      urgent,
      icon,
      hideWhenZero,
    }));
  };

  if (statsConfig.type === "grouped") {
    const groups = statsConfig.groups.map((group, i) => ({
      title: group.title,
      stats: [
        ...(i === 0 ? [totalApplications] : []),
        ...buildItems(group.items, sources[group.source]),
      ],
    }));
    return { groups };
  }

  return {
    stats: [
      totalApplications,
      ...buildItems(statsConfig.items, sources[statsConfig.source]),
    ],
  };
};
